import Cookies from 'js-cookie'
import { companyInfoGet } from '@/api'
import { Message } from 'element-ui'

const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 6)
}

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  webInfo: {
    aboutUs: undefined,
    address: undefined,
    companyName: undefined,
    createTime: undefined,
    email: undefined,
    id: undefined,
    logo: undefined,
    phone: undefined,
    qq: undefined,
    wechat: undefined,
    weCom: undefined
  },
  device: 'desktop',
  checkedStudentData: null,
  studentList: []
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  GETWEBINFO: (state, webInfo) => {
    state.webInfo = webInfo
  },
  SET_CHECKEDSTUDENT: (state, studentData) => {
    state.checkedStudentData = studentData
  },
  CLEAR_CHECKEDSTUDENT: (state) => {
    state.checkedStudentData = null
  },
  SET_STUDENT: (state, student) => {
    state.studentList.push(student)
  },
  SET_STUDENT_ARR: (state, studentList) => {
    state.studentList = studentList
  },
  DEL_STUDENT: (state, students) => {
    // 如果传入的是单个学生对象或单个 ID，将其转换为数组
    const studentsArray = Array.isArray(students) ? students : [students]

    // 提取需要删除的学生 ID
    const idsToDelete = studentsArray.map((student) => {
      if (typeof student === 'object' && student.id) {
        return student.id
      }
      return student
    })

    // 遍历 studentList 并删除匹配的 ID
    state.studentList = state.studentList.filter((item) => {
      return !idsToDelete.includes(item.id)
    })
  },
  UPDATE_STUDENT: (state, student) => {
    state.studentList.map((item, index) => {
      if (item.id === student.id) {
        state.studentList.splice(index, 1, student)
      }
    })
  }
}

const actions = {
  toggleSideBar ({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar ({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice ({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setCheckedStudent ({ commit }, studentData) {
    commit('SET_CHECKEDSTUDENT', studentData)
  },
  clearCheckedStudent () {
    commit('CLEAR_CHECKEDSTUDENT')
  },
  // 设置学生信息
  setStudent ({ state, commit }, student) {
    return new Promise((resolve, reject) => {
      // 检查身份证号是否重复
      const existingIdCard = state.studentList.some(s => s.idCard === student.idCard)
      if (existingIdCard) {
        Message.error('身份证号已存在！')
        return reject(new Error('身份证号已存在！'))
      }
      // 检查手机号是否重复
      const existingPhone = state.studentList.some(s => s.phone === student.phone)
      if (existingPhone) {
        Message.error('手机号已存在！')
        return reject(new Error('手机号已存在！'))
      }
      // 生成唯一 ID
      student.id = generateId()
      commit('SET_STUDENT', student)
      // 返回成功
      resolve(student)
    })
  },
  setStudentArr ({ commit }, resStudentList) {
    return new Promise((resolve) => {
      commit('SET_STUDENT_ARR', resStudentList)
      // 返回成功
      resolve(student)
    })
  },
  // 删除学生
  deleteStudent ({ commit }, student) {
    commit('DEL_STUDENT', student)
  },
  // 修改学生
  updateStudent ({ commit }, student) {
    return new Promise((resolve, reject) => {
      // 检查身份证号是否重复
      const existingIdCard = state.studentList.some(s => {
        return (s.idCard === student.idCard && s.id !== student.id)
      })
      if (existingIdCard) {
        Message.error('身份证号已存在！')
        return reject(new Error('身份证号已存在！'))
      }
      // 检查手机号是否重复
      const existingPhone = state.studentList.some(s => {
        return (s.phone === student.phone && s.id !== student.id)
      })
      if (existingPhone) {
        Message.error('手机号已存在！')
        return reject(new Error('手机号已存在！'))
      }
      commit('UPDATE_STUDENT', student)
      // 返回成功
      resolve(student)
    })
  },
  // 获取网站信息
  GetWebInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      companyInfoGet(state.token).then(response => {
        const { data } = response
        commit('GETWEBINFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
